if (!customElements.get('gg-click-collect')) {
  customElements.define('gg-click-collect', class extends HTMLElement {
    connectedCallback() {
      const H = window.GgStoreHours;
      if (!H || this.timer) return;
      const d = this.dataset;
      const status = this.querySelector('[data-status]');
      const statusLabel = this.querySelector('[data-status-label]');
      const title = this.querySelector('[data-cd-title]');
      const sub = this.querySelector('[data-cd-sub]');
      const rows = this.querySelectorAll('[data-day]');

      this.timer = H.watch(this, (s) => {
        rows.forEach((r) => r.classList.toggle('is-today', +r.dataset.day === s.todayIndex));
        // No open days configured: keep the neutral pre-JS text.
        if (!s.open && !s.vars.next_open) return '';
        const label = H.fill(s.open ? d.statusOpen : d.statusClosed, s.vars);
        statusLabel.textContent = label;
        status.hidden = false;
        this.classList.toggle('is-open', s.open);
        this.classList.toggle('is-same-day', s.sameDay);
        title.textContent = H.fill(s.sameDay ? d.sameTitle : d.laterTitle, s.vars);
        sub.textContent = H.fill(s.sameDay ? d.sameSub : d.laterSub, s.vars);
        sub.hidden = !sub.textContent;
        return label + '. ' + title.textContent;
      });
    }

    disconnectedCallback() {
      clearInterval(this.timer);
      this.timer = null;
    }
  });
}
